import React, {useState} from "react";
import * as Styled from "./SssContentStyled";
import Image from "next/image";
import FaqData from "../../constants/data/FaqData";
import Accordion from "../accordion/Accordion";
import FaqButtons from "./CheckboxButton";
import FaqAccordion from "../accordion/FaqAccordion";
import GeneralBreadcrumb from "../breadcrumb/GeneralBreadcrumbComp";
import {NavigationURLs} from "../../functions/NavigationFunctions";


const SssContent = () => {

    const [item, setItem] = useState<any>(FaqData.filter((item: any) => item.title === "GENEL"));

    // @ts-ignore
    const menuItems = [...new Set(FaqData.map((Val) => Val.title))];

    const filterItem = (curcat: any) => {
        const newItem = FaqData.filter((newVal) => {
            return newVal.title === curcat;
        });
        setItem(newItem);
    };

    const breadcrumbItems = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Yardım'}
    ];

    return (
        <React.Fragment>
            <Styled.SssContentWrapper>
                <GeneralBreadcrumb items={breadcrumbItems} margin={false} colorProps={false}/>
                <Styled.SssContentContainer>
                    <Styled.SssContentTitle>
                        Pembe Panjur YARDIM
                    </Styled.SssContentTitle>
                    <Styled.SssContentRow>
                        <Styled.SssContentRowWrapper>
                            <Styled.SssContentRowIcon>
                                <Image src={'/next/assets/images/sss-icon.png'} width={97} height={125} alt={'sss'}/>
                            </Styled.SssContentRowIcon>
                            <Styled.SssContentRowDetail>
                                <Styled.SssContentRowDetailTitle>
                                    Sıkça Sorulan Sorular. Lütfen aradığınız yardıma ait cevapları görebilmek için
                                    kategorilerinizi seçin:
                                </Styled.SssContentRowDetailTitle>
                                <Styled.SssContentRowDetailOption>
                                    <FaqButtons
                                        filterItem={filterItem}
                                        setItem={setItem}
                                        menuItems={menuItems}
                                    />
                                </Styled.SssContentRowDetailOption>
                            </Styled.SssContentRowDetail>
                        </Styled.SssContentRowWrapper>
                        <Styled.SssContentRowLine/>
                        <Styled.SssContentColumnWrapper>
                            {item.map((Val: any) => (
                                <React.Fragment key={Math.random()}>
                                    {Val.items.map((item: any) => (
                                        <Accordion key={Math.random()} item={item}/>
                                    ))}
                                </React.Fragment>
                            ))}

                        </Styled.SssContentColumnWrapper>
                        <Styled.SssContentColumnWrapperMobile>
                            {FaqData.map((Val: any) => (
                                <FaqAccordion key={Math.random()} item={Val}/>
                            ))}
                        </Styled.SssContentColumnWrapperMobile>

                    </Styled.SssContentRow>
                </Styled.SssContentContainer>

            </Styled.SssContentWrapper>
        </React.Fragment>
    )
}


export default SssContent;
